export const appDocsIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path fill="currentColor" d="M14 4l5 5.004V18.4c0 .88-.788 1.6-1.75 1.6H6.741C5.78 20 5 19.28 5 18.4l.009-12.8c0-.88.778-1.6 1.741-1.6H14zm2 11H8v2h8v-2zm0-4H8v2h8v-2z"/></g></svg>`,
    name: 'docs' as const
};